import { render, staticRenderFns } from "./VTopTable.vue?vue&type=template&id=0c8d4172&"
import script from "./VTopTable.vue?vue&type=script&lang=js&"
export * from "./VTopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports